//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url + Vue.prototype.$config.ticket.ticket_detail

const ticket = {
  create(payload:any) {
    return Vue.prototype.$httpService
      .post(url, payload)
  },
  find(id:string|number) {
    return Vue.prototype.$httpService
      .get(url + "/" + id)
  },
  partial_edit(id:string|number, payload:any){
    let uri = url.replace("{0}",id) 
    return Vue.prototype.$httpService.put(uri,payload)
  },
  list(center_execute_id:string|number, case_id:string|number, competency_id:string|number, params = {}) {
    let uri = url.replace("{0}", center_execute_id).replace("{1}", case_id).replace("{2}", competency_id);
    return Vue.prototype.$httpService.get(uri,
      params
    )
  },
}

export default ticket;

